import { useContext, useState } from "react";

//components
import { LeadForm } from "components/LeadForm";
import Modal from "../../../LoginAndRegister/Modal";
import Calculations from "../Calculations";
import { ListingCoupon } from "../ListingCoupon";
import { default as StatusTag } from "../StatusTag";
import DrawerContent from "./BookingDrawerContent";

// context
import { ListingInterface } from "context/ListingData";

// custom hook
import { useMediaQuery } from "customHooks/useMediaQuery";

//assets
import SvgInfoBlue from "assets/icons/js/SvgInfoBlue";
import { SvgRightArrow } from "assets/icons/js/SvgRightArrow";
import { SvgUseCoupon } from "assets/icons/js/SvgUseCoupon";
import { ReactComponent as SvgGreenCoupon } from "assets/coupon.svg";
import { ReactComponent as Loader } from "assets/spinning_wheel.svg";

// helpers
import addCommas from "helpers/addCommasToNumber";
import { formatDate } from "helpers/dateFormatter";

// scss
import { axiosInstance } from "helpers/axiosInstance";
import moment from "moment";
import { useQuery } from "react-query";
import ListingWeekDayOfferGst from "../ListingWeekdayOfferGst";
import { ListingWeekdayPhoneOfferGst } from "../ListingWeekdayPhoneOfferGst";
import "./style.scss";
import { UserContext } from "store";
import { SvgCoupon } from "assets/icons/js/SvgCoupon";
import { FinishPhoneSignup } from "components/LoginAndRegister/FinishPhoneSignup";
import { useTheme } from "components/ListingNew/ListingTheme";
import { AskMeModal } from "components/Booking/AskHelp";
import { WeeklyOfferChecker } from "helpers/checkWeekendOffer";
import { useSearchParams } from "react-router-dom";

const BookingDetailsFlow = ({
	id,
	openDrawer = false,
	setOpenDrawer,
	dates,
	setDates,
	calculations = {},
	calError = false,
	calLoading = false,
	blocked,
	handleButtonClick,
	spl,
	storedDates,
	newCalculations,
	newDates,
}) => {
	// @ts-ignore
	const {
		data,
		childrenData,
		adultsData,
		infantsData,
		roomsData,
		isFromGoogle,
	} = useContext(ListingInterface);

	const listingList = data?.data?.listing_list;
	// const discount = listingList?.DISCOUNT_7_DAYS
	// 	? listingList?.DISCOUNT_7_DAYS
	// 	: listingList?.DISCOUNT_28_DAYS;
	// const pricePerNight = listingList?.PER_NIGHT_CHARGE;
	const sameDay = listingList?.same_day_booking;

	const width = useMediaQuery();
	const isMobile = width < 700;

	const fetchCouponsListings = useQuery(
		[
			"get coupons",
			dates?.checkin,
			dates?.checkout,
			childrenData,
			adultsData,
			infantsData,
			roomsData,
		],
		() =>
			// @ts-ignore
			axiosInstance({
				method: "GET",
				url: `/ss3/fetch/coupons/new?FROM_DATE=${
					dates?.checkin ? moment(dates?.checkin).format("YYYY-MM-DD") : ""
				}&TO_DATE=${
					dates?.checkout ? moment(dates?.checkout).format("YYYY-MM-DD") : ""
				}&LISTING_ID=${
					listingList.id
				}&NUM_ROOMS=${roomsData}&NUM_ADULTS=${adultsData}&NUM_CHILD=${childrenData}&NUM_INFANTS=${infantsData}`,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				},
			}),
	);

	//---calculations on mobile view
	const [showCalculations, setShowCalculations] = useState(false);
	const [content, setContent] = useState("guests");
	const [shouldCouponShowModal, setShouldCouponShowModal] = useState(false);
	const [showLeadFormModal, setShowLeadFormModal] = useState(false);

	const [showCouponModal, setShowCouponModal] = useState(false);

	const closeCouponModal = () => {
		setShouldCouponShowModal(false);
	};

	const closeLeadFormModal = () => {
		setShowLeadFormModal(false);
	};
	const onClose = () => {
		setOpenDrawer(false);
	};

	const dynamicPricePerNight =
		Object.keys(calculations).length > 0
			? (calculations.ROOM_CHARGES +
					calculations.meal_total +
					calculations.EXTRA_CHARGES) /
			  calculations.numNights
			: listingList?.per_night_charge;

	const location = window.location.pathname.split("/")[2].split("-");
	const newId = location[location.length - 1];

	const checkDiffIn = moment(dates.checkin);
	const checkDiffOut = moment(dates.checkout);
	const dateDiff = Math.abs(checkDiffIn.diff(checkDiffOut, "days"));

	const { dispatch } = useContext(UserContext);

	const theme = useTheme();

	const [askOpen, setAskOpen] = useState(false);

	const [roomOffer, setRoomOffer] = useState(false);
	const [searchParams] = useSearchParams();
	const btnText =
		searchParams?.get("checkin") && searchParams?.get("checkout")
			? "Book Now"
			: "Check Availability";

	return (
		<div
			className="booking-details-container"
			style={{ background: theme.background }}
		>
			{/* {fetchCouponsListings?.data?.data?.data[0].discount ? (
				<div className="save-dis-tag">
					Save ₹{addCommas(fetchCouponsListings?.data?.data?.data[0].discount)}+
				</div>
			) : null} */}

			{
				// theme?.name !== "xseries" ?
				listingList?.unlock_magic === "N" &&
					(Object.keys(calculations).length !== 0 &&
					calculations.discount_amount ? (
						<>
							<div
								className="show-price-wrapper"
								style={{
									marginBottom: 0,
								}}
								onClick={() => setShowCalculations(true)}
							>
								<div>
									<SvgGreenCoupon />
									Coupon is applied when you book
								</div>
								<SvgRightArrow
									color={"#000000"}
									style={{ transform: "rotate(-90deg)" }}
								/>
							</div>

							{WeeklyOfferChecker(dates.checkin, dates.checkout) && (
								<p
									onClick={() => {
										setRoomOffer(true);
										setAskOpen(true);
									}}
									className=" clr-grey"
									style={{
										fontSize: "12px",
										background: calculations?.discount_amount && "#F3FEF3",
										borderRadius: "4px",
										padding: "4px",
									}}
								>
									Want to book fewer rooms?{" "}
									<span
										style={{ cursor: "pointer", textDecoration: "underline" }}
									>
										Click here
									</span>
								</p>
							)}
						</>
					) : (
						<div className="show-price-wrapper dates-nudge-wrapper">
							<div>
								<SvgGreenCoupon />
								Add dates for best price
							</div>
						</div>
					))
				// : null
			}
			{listingList?.unlock_magic === "N" ? (
				<>
					{
						dateDiff !== 2 && dates.checkin && dates.checkout
							? newDates.checkin &&
							  newDates.checkout &&
							  calculations.room_charge - newCalculations.room_charge > 0 && (
									<div className="booking__price-coupon">
										<div className="use-coupon">
											<span className="coupon-icon">
												<SvgUseCoupon />
												<p>
													Save ₹
													{addCommas(
														calculations.room_charge -
															newCalculations.room_charge,
													)}
													+
												</p>
											</span>
											<div
												className="view-offers"
												onClick={() => {
													setDates({
														checkin: new Date(newDates.checkin),
														checkout: new Date(newDates.checkout),
													});

													setShowCalculations(true);
												}}
											>
												<p>Book for {formatDate(newDates.checkin)}</p>
												<SvgRightArrow color={"#11bf0e"} />
											</div>
										</div>
									</div>
							  )
							: null

						/* <div className="booking__price-coupon">
								<div className="use-coupon">
									<span className="coupon-icon">
										<SvgUseCoupon />
									</span>
									<div
										className="view-offers"
										onClick={() => setShouldShowModal(true)}
									>
										<p>View Offers</p>
										<SvgRightArrow color={"#11bf0e"} />
									</div>
								</div>
							</div> */
					}

					{/* {dateDiff === 2 && (
						<ListingWeekdayPhoneOfferGst
							dates={dates}
							setDates={setDates}
							setShowCalculations={setShowCalculations}
						/>
					)} */}
				</>
			) : (
				<button
					aria-label="book now"
					type="button"
					className="book-button text-xsm not-avail font-heading spacing-1"
					onClick={() => setShowLeadFormModal(true)}
				>
					Reserve Now
				</button>
			)}
			{/* {listingList.priceWithoutgenDis - dynamicPricePerNight > 0 ||
			listingList.priceWithoutgenDis - listingList?.PER_NIGHT_CHARGE_REAL >
				0 ? (
				<ListingTimer />
			) : null} */}

			<div className="booking-details__wrapper">
				{calError && <StatusTag color={"white"}>{calError}</StatusTag>}

				{/* {!calLoading && !calError && (
					<div className="booking-details__discount text-12px-bold">
						{" "}
						You are saving : ₹{addCommas(listingList.priceWithoutgenDis)}
					</div>
				)} */}
				{/* {theme?.name === "xseries" && (
					<div
						className="booking-details__price"
						style={{
							flexDirection: "row",
							justifyContent: "space-between",
							width: "-webkit-fill-available",
						}}
					>
						<div className="booking-details__price">
							<span style={{ fontSize: "13px", color: theme.primaryTextColor }}>
								Starting
							</span>

							<span
								className="sub-heading"
								style={{ color: theme.primaryTextColor }}
							>
								₹ {addCommas(listingList?.per_night_charge)}{" "}
								<span
									className="text-12px"
									style={{ color: theme.primaryTextColor }}
								>
									/ night
								</span>
								<br />
							</span>
						</div>

						<button
							aria-label="book-now"
							style={{
								background: theme?.bookingBtnBackground,
							}}
							className="check-availability"
						>
							<div
								className="text-sm-bold"
								style={{ color: "black" }}
								onClick={() => {
									if (!calError && Object.keys(calculations).length > 0)
										dispatch({
											type: "FROM_BOOK_BUTTON",
											payload: true,
										});
									setAskOpen(true);
								}}
							>
								Request to Book
							</div>
						</button>
					</div>
				)} */}
				{
					// theme?.name !== "xseries" &&
					listingList?.unlock_magic === "N" &&
					listingList.classification &&
					!calLoading ? (
						<>
							<div
								className="booking-details__price"
								onClick={() => {
									if (Object.keys(calculations).length !== 0)
										setShowCalculations(true);
								}}
							>
								{Object.keys(calculations).length > 0 ? (
									calculations.discount_amount ? (
										<div className="booking-details__price">
											<span
												className="phone__price-listing sub-heading"
												style={{
													textDecoration: "none",
													color: theme.primaryTextColor,
												}}
											>
												<b style={{ fontSize: "16px" }}>
													₹{" "}
													{addCommas(
														isFromGoogle
															? calculations.TOTAL_AMOUNT
															: calculations.total_amount_with_discount,
													)}
												</b>{" "}
												{!isFromGoogle && (
													<s
														style={{
															color: "#666666",
															fontSize: "12px",
														}}
													>
														₹{" "}
														{addCommas(calculations?.TOTAL_AMOUNT_WITH_SERVICE)}
													</s>
												)}
											</span>
											<span
												className=" text-12px"
												style={{ color: theme.primaryTextColor }}
											>
												{calculations?.discount_amount
													? "Total after discount"
													: "₹" + addCommas(dynamicPricePerNight)}
												{/* <p className="sub-heading-price">+ (GST)</p> */}
												{/* {listingList.priceWithoutgenDis > 0 && (
										<span className="text-12px clr-grey">
											₹{addCommas(listingList.priceWithoutgenDis)}
										</span>
									)} */}
												{/* <SvgRightArrow
											color={"#000000"}
											style={{ transform: "rotate(-90deg)" }}
										/> */}
											</span>
										</div>
									) : (
										<div
											className="booking-details__price"
											onClick={() => setShowCalculations(true)}
										>
											<span
												className="text-12px"
												style={{ color: theme.primaryTextColor }}
											>
												Total Amount <SvgInfoBlue />
											</span>
											<span
												className="phone__price-listing sub-heading"
												style={{ color: theme.primaryTextColor }}
											>
												₹
												{calculations?.sub_total ||
													addCommas(calculations?.TOTAL_AMOUNT_WITH_SERVICE)}
												<p className="sub-heading-price"> (incl. GST)</p>
												{/* {listingList.priceWithoutgenDis > 0 && (
										<span className="text-12px clr-grey">
											₹{addCommas(listingList.priceWithoutgenDis)}
										</span>
									)} */}
												<SvgRightArrow
													color={"#000000"}
													style={{ transform: "rotate(-90deg)" }}
												/>
											</span>
										</div>
									)
								) : (
									<div className="booking-details__price">
										<span
											style={{
												fontSize: "13px",
												color: theme.primaryTextColor,
											}}
										>
											Starting
										</span>
										{listingList.priceWithoutgenDis - dynamicPricePerNight >
											0 ||
										listingList.priceWithoutgenDis -
											calculations.defaultTotalTariffWithoutGst >
											0 ? (
											<span className="text-12px clr-grey line-through">
												₹{addCommas(listingList.priceWithoutgenDis)}
											</span>
										) : null}
										<span
											className="sub-heading"
											style={{ color: theme.primaryTextColor }}
										>
											₹ {addCommas(dynamicPricePerNight)}{" "}
											<span
												className="text-12px"
												style={{ color: theme.primaryTextColor }}
											>
												/ night
											</span>
											<br />
											<span
												className="text-12px"
												style={{
													marginTop: -4,
													display: "block",
													color: theme.primaryTextColor,
												}}
											>
												{calculations?.booking_fee_tax && listingList.min_rooms
													? ""
													: listingList.TYPE_FLAG !== "MR" &&
													  listingList.min_rooms > 1 &&
													  `(${(
															dynamicPricePerNight / listingList.min_rooms
													  )?.toLocaleString("en-IN", {
															currency: "INR",
															style: "currency",
													  })} x ${listingList.min_rooms} Rooms)`}
											</span>
										</span>
									</div>
								)}
							</div>
							{/*
							{theme?.name === "xseries" ? (
								<button
									aria-label="book-now"
									style={{ background: theme?.bookingBtnBackground }}
									className="check-availability"
								>
									<div
										className="text-sm-bold"
										style={{ color: "black" }}
										onClick={() => {
											if (!calError && Object.keys(calculations).length > 0)
												dispatch({
													type: "FROM_BOOK_BUTTON",
													payload: true,
												});
											setAskOpen(true);
										}}
									>
										Request to Book
									</div>
								</button>
							) : ( */}
							<button
								aria-label="book-now"
								className="check-availability"
								style={{ background: theme.bookingBtnBackground }}
							>
								<div
									className="text-sm-bold"
									style={{ color: theme.background }}
									onClick={() => {
										if (!calError && Object.keys(calculations).length > 0)
											dispatch({
												type: "FROM_BOOK_BUTTON",
												payload: true,
											});
										handleButtonClick();
									}}
								>
									{calLoading ? (
										<Loader
											style={{
												width: "30px",
												height: "20px",
											}}
										/>
									) : (
										btnText
									)}
								</div>
							</button>
							{/* )} */}
						</>
					) : null
				}
				{listingList?.unlock_magic === "N" &&
				listingList?.classification === 0 &&
				!calLoading ? (
					<>
						<div
							className="booking-details__price"
							onClick={() => {
								if (Object.keys(calculations).length !== 0)
									setShowCalculations(true);
							}}
						>
							{Object.keys(calculations).length > 0 ? (
								calculations.discount_amount ? (
									<div className="booking-details__price">
										<span
											className="phone__price-listing sub-heading"
											style={{
												textDecoration: "none",
												color: theme.primaryTextColor,
											}}
										>
											<b style={{ fontSize: "16px" }}>
												₹{" "}
												{addCommas(
													Math.round(calculations.total_amount_with_discount),
												)}
											</b>{" "}
											{!isFromGoogle && (
												<s
													style={{
														color: "#666666",
														fontSize: "12px",
													}}
												>
													₹ {addCommas(calculations.TOTAL_AMOUNT_WITH_SERVICE)}
												</s>
											)}
										</span>
										<span
											className=" text-12px"
											style={{ color: theme.primaryTextColor }}
										>
											{calculations?.ROOM_CHARGES
												? "Total after discount"
												: "₹" + addCommas(dynamicPricePerNight)}
											{/* <p className="sub-heading-price">+ (GST)</p> */}
											{/* {listingList.priceWithoutgenDis > 0 && (
										<span className="text-12px clr-grey">
											₹{addCommas(listingList.priceWithoutgenDis)}
										</span>
									)} */}
											{/* <SvgRightArrow
											color={"#000000"}
											style={{ transform: "rotate(-90deg)" }}
										/> */}
										</span>
									</div>
								) : (
									<div
										className="booking-details__price"
										onClick={() => setShowCalculations(true)}
									>
										<span
											className="text-12px"
											style={{ color: theme.primaryTextColor }}
										>
											Total Amount <SvgInfoBlue />
										</span>
										<span
											className="phone__price-listing sub-heading"
											style={{ color: theme.primaryTextColor }}
										>
											₹
											{calculations?.TOTAL_AMOUNT_WITH_SERVICE
												? calculations?.TOTAL_AMOUNT_WITH_SERVICE
												: addCommas(dynamicPricePerNight)}
											<p className="sub-heading-price">+ (GST)</p>
											{/* {listingList.priceWithoutgenDis > 0 && (
										<span className="text-12px clr-grey">
											₹{addCommas(listingList.priceWithoutgenDis)}
										</span>
									)} */}
											<SvgRightArrow
												color={"#000000"}
												style={{ transform: "rotate(-90deg)" }}
											/>
										</span>
									</div>
								)
							) : (
								<div className="booking-details__price">
									{listingList.priceWithoutgenDis - dynamicPricePerNight > 0 ||
									listingList.priceWithoutgenDis -
										calculations.defaultTotalTariffWithoutGst >
										0 ? (
										<span className="text-12px clr-grey line-through">
											₹{addCommas(listingList.priceWithoutgenDis)}
										</span>
									) : null}
									<span
										className="sub-heading"
										style={{ color: theme.primaryTextColor }}
									>
										₹{" "}
										{addCommas(
											listingList.TYPE_FLAG === "MR" ||
												listingList.TYPE_FLAG === "MV"
												? Math.round(
														(dynamicPricePerNight * roomsData) /
															(childrenData + adultsData),
												  )
												: Math.round(
														dynamicPricePerNight / (childrenData + adultsData),
												  ),
										)}{" "}
										<span
											className="text-12px"
											style={{ color: theme.primaryTextColor }}
										>
											/ person
										</span>
									</span>
								</div>
							)}
						</div>

						{/* {theme?.name === "xseries" ? (
								<button
									aria-label="book-now"
									style={{ background: theme?.bookingBtnBackground }}
									className="check-availability"
								>
									<div
										className="text-sm-bold"
										style={{ color: "black" }}
										onClick={() => {
											if (!calError && Object.keys(calculations).length > 0)
												dispatch({
													type: "FROM_BOOK_BUTTON",
													payload: true,
												});
											setAskOpen(true);
										}}
									>
										Request to Book
									</div>
								</button>
							) : ( */}
						<button aria-label="book-now" className="check-availability">
							<div
								className="text-sm-bold clr-white"
								onClick={() => {
									if (!calError && Object.keys(calculations).length > 0)
										dispatch({
											type: "FROM_BOOK_BUTTON",
											payload: true,
										});
									handleButtonClick();
								}}
							>
								{calLoading ? (
									<Loader
										style={{
											width: "30px",
											height: "20px",
										}}
									/>
								) : (
									btnText
								)}
							</div>
						</button>
						{/* )} */}
					</>
				) : null}
				<AskMeModal
					open={askOpen}
					setOpen={setAskOpen}
					data={{
						theme: theme,
						LISTING_ID: listingList?.id,
						FROM_DATE:
							Object.keys(calculations).length > 0
								? calculations.FROM_DATE
								: "NA",
						TO_DATE:
							Object.keys(calculations).length > 0
								? calculations.TO_DATE
								: "NA",
						NO_OF_GUESTS:
							Object.keys(calculations).length > 0
								? calculations.NO_OF_GUESTS
								: listingList?.max_capacity,
						NO_OF_ROOMS:
							Object.keys(calculations).length > 0
								? calculations.NO_OF_ROOMS
								: listingList?.num_similar_rooms,
						TOTAL_AMOUNT_WITH_SERVICE:
							Object.keys(calculations).length > 0
								? calculations.TOTAL_AMOUNT_WITH_SERVICE
								: listingList?.per_night_charge,
						isListing: true,
						isReserveNow: roomOffer ? false : true,
						showLessRoom: roomOffer,
						allowSelectLessRoom: roomOffer,
					}}
				/>
				<Modal
					shouldShow={shouldCouponShowModal}
					onRequestClose={closeCouponModal}
				>
					<ListingCoupon closeModal={closeCouponModal} dates={dates} id={id} />
				</Modal>
				<Modal shouldShow={openDrawer} onRequestClose={onClose}>
					<DrawerContent
						closeDrawer={() => setOpenDrawer(false)}
						listingList={listingList}
						dates={dates}
						setDates={setDates}
						blocked={blocked}
						onClose={onClose}
						setContent={setContent}
						content={content}
						sameDay={sameDay}
						spl={spl}
						storedDates={storedDates}
						openDrawer={openDrawer}
					/>
				</Modal>
				{calculations && (
					<Modal
						shouldShow={showCalculations}
						onRequestClose={() => setShowCalculations(false)}
					>
						<Calculations
							calculations={calculations}
							calLoading={calLoading}
							calError={calError}
							mealRequired={listingList.meal_required === "1"}
							openDrawer={showCalculations}
							setShowCalculations={setShowCalculations}
							setOpenDrawer={setOpenDrawer}
							handleButtonClick={handleButtonClick}
							onClose={() => setShowCalculations(false)}
							setContent={setContent}
							dates={dates}
							listingList={listingList}
							newDates={newDates}
							newCalculations={newCalculations}
							setDates={setDates}
						/>
					</Modal>
				)}
				<Modal
					shouldShow={showLeadFormModal}
					onRequestClose={closeLeadFormModal}
				>
					<LeadForm closeModal={closeLeadFormModal} listingID={newId || id} />
				</Modal>
				<Modal
					shouldShow={showCouponModal}
					onRequestClose={() => setShowCouponModal(false)}
				>
					<ListingCoupon
						closeModal={() => setShowCouponModal(false)}
						fetchCouponsListings={fetchCouponsListings}
					/>
				</Modal>
				<Modal
					shouldShow={
						calError === "Mobile Number is missing" ||
						calError === "Email_id is missing" ||
						calError === "Please help us with your Name"
							? true
							: false
					}
					onRequestClose={undefined}
				>
					<FinishPhoneSignup
						userUUID={localStorage.getItem("uuid")}
						redirect={() => window.location.reload()}
					/>
				</Modal>
			</div>
		</div>
	);
};

export default BookingDetailsFlow;
